import React, { memo, useState } from "react";
import PropTypes from "prop-types";

import noPrdImage from "../../assets/images/placeholder.png";
import { getBucketUrl } from "../../utils/GeneralFunc";


const Image = ({
  src,
  alt,
  className = "",
  fallbackSrc = noPrdImage,
  loading = "lazy",
  decoding = "async",
  ...rest
}) => {
  const [imgSrc, setImgSrc] = useState(() => getBucketUrl(src));

  const handleError = () => {
    // prevent infinite loop
    if (imgSrc !== fallbackSrc) {
      setImgSrc(fallbackSrc);
    }
  };

  return (
    <img
      src={imgSrc}
      alt={alt || "image"}
      className={className}
      loading={loading}
      decoding={decoding}
      onError={handleError}
      {...rest}
    />
  );
};

Image.propTypes = {
  src: PropTypes.string,
  alt: PropTypes.string,
  className: PropTypes.string,
  fallbackSrc: PropTypes.string,
  loading: PropTypes.oneOf(["lazy", "eager"]),
  decoding: PropTypes.oneOf(["sync", "async", "auto"]),
};

export default memo(Image);